import { Component } from '@theme/component';

class FeaturedContentCarousel extends Component {
  requiredRefs = ['swiper'];

  #swiper = null;

  connectedCallback() {
    super.connectedCallback();

    this.#initSwiper();
  }

  get mobileSlides() {
    return Number(this.dataset.mobileSlides);
  }

  get desktopSlides() {
    return Number(this.dataset.desktopSlides);
  }

  #initSwiper() {
    if (! this.refs.swiper) {
      return;
    }

    this.#swiper = new window.Swiper(this.refs.swiper, {
      loop: true,
      allowTouchMove: true,
      slidesPerView: 1,
      spaceBetween: 20,
      centeredSlides: true,
      
      breakpoints: {
        750: {
          slidesPerView: 3,
        }
      }
    })
  }
  
  slideNext(){
    this.#swiper.slideNext();
  }

  slidePrev() {
    this.#swiper.slidePrev();
  }
}

if (!customElements.get('featured-content-carousel')) {
  customElements.define('featured-content-carousel', FeaturedContentCarousel);
}